import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
// import {CookieService} from 'ngx-cookie-service';


export interface LoginResponse extends Object {
  cookie: any,
  passport: any
}


@Component({
  selector: 'app-rosetta-catalog',
  templateUrl: './rosetta-catalog.component.html',
  styleUrls: ['./rosetta-catalog.component.css']
})
export class RosettaCatalogComponent implements OnInit {

  public form: any;
  public error:string;
  public finished: boolean;
  public iframeURL: SafeUrl;
  public loading: boolean;
  

  public submit(form) {
    // if (!(form.name && form.email && form.phone && form.referral && form.inquiry)) {
    //   this.error = "Please fill out all fields.";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(form.email))) {
    //   this.error = "Please enter a valid email address.";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // if (form.inquiry && (form.inquiry === 'dealer' || form.inquiry === 'builder') && !(form.company && form.state && form.position)) {
    //   this.error = "Please tell us about you and your company";
    //     setTimeout(() => {
    //       this.error = null;
    //     }, 1000);
    //   return;
    // }
    // this.connectService.submit(form);
    this.submitAuth(form);
    console.log("FORM: ", form);
    this.finished = true;


  }

  public submitAuth (form) {


    // console.log(form);
    if (!(form.username && form.email && form.password)) {
      this.error = "Please fill out all fields.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
      return;
    }
    if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(form.email))) {
      this.error = "Please enter a valid email address.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
      return;
    }

    this.loading = true;
    form.referrer = 'rosetta';





    return this.http.post<LoginResponse>('/login/password', form)
      .subscribe(res => {
        console.log("submit: ", res);
          // return true;
          if (res.cookie) {
            
            // document.cookie = "catalog_enabled=true;SameSite=None;secure";
            sessionStorage.setItem('catalog_enabled', 'true');

          }
          this.getCatalogURL();
        }, (err) => {
          console.error("submit: ", err);
          this.loading = false;
        }
      );
  }

  public getCatalogURL () {
    this.loading = true;
    this.http.get<any>('/rosetta-catalog-url').subscribe(catalogRes => {
      console.log("catalogRes: ", catalogRes);
      this.loading = false;
      this.iframeURL =  this.sanitizer.bypassSecurityTrustResourceUrl(catalogRes.url);
      return true;
    },
      (err)=>{
        this.loading = false;
        console.error("catalogErr: ", err);
      });
  }

  // private setCookie(params: any) {
  //   console.log("setCookie: ", params);
  //   let d: Date = new Date();
  //   d.setTime(
  //     d.getTime() +
  //       (params.expireDays ? params.expireDays : 1) * 24 * 60 * 60 * 1000
  //   );
  //   document.cookie =
  //     (params.name ? params.name : '') +
  //     '=' +
  //     (params.value ? params.value : '') +
  //     ';' +
  //     (params.session && params.session == true
  //       ? ''
  //       : 'expires=' + d.toUTCString() + ';') +
  //     'path=' +
  //     (params.path && params.path.length > 0 ? params.path : '/') +
  //     ';' +
  //     ('secure;') + 
  //       'SameSite=None';
  // }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer,     ) { }

  ngOnInit() {
    this.form = {};
    this.loading = true;
    if (sessionStorage.getItem('catalog_enabled')) {
      this.getCatalogURL();

    } else {
      this.loading = false;
    }

  }
}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/rosetta-catalog/rosetta-catalog.component.ts